/** Ramène une valeur dans [0..1] ; NaN → 0. */
export function clamp01(v: number): number {
  if (Number.isNaN(v)) return 0;
  return Math.min(1, Math.max(0, v));
}

export function smoothstep(edge0: number, edge1: number, v: number): number {
  const x = clamp01((v - edge0) / (edge1 - edge0));
  return x * x * (3 - 2 * x);
}

export function median(values: readonly number[]): number {
  if (values.length === 0) return Number.NaN;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 1
    ? (sorted[mid] as number)
    : ((sorted[mid - 1] as number) + (sorted[mid] as number)) / 2;
}
